import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable } from 'rxjs';
import { DepartmentApiModel } from 'app/models/department-api.model';

@Injectable()
export class MwDepartmentsApiService {
  constructor(private http: MwHttpService) {}

  getDepartments(): Observable<DepartmentApiModel[]> {
    return this.http.authGet<DepartmentApiModel[]>(
      `/integration/v1/Companies/{companyId}/Departaments?$orderby=Name`
    );
  }
}
